import React, { useEffect, useState } from 'react'
import { MainBox } from '../../styles'
import { httpsCallable } from 'firebase/functions';
import { functions } from '../../../../Infrastructure/config';
import useAuthentication from '../../../../Infrastructure/States/onAuthStateChange';
import { Box, Typography } from '@mui/material'
import { CoursesHistory } from './Courses/coursesHistory';
import { Refunds } from './Refunds/refunds';
import { Loader } from '../../../Common/Loader/loader';
import ERROR_CONSTANTS from '../../../../Infrastructure/Constants/errorConstants';
import { ErrorView } from '../../../Common/ErrorComponents/errorView';
import { useSelector } from 'react-redux';
import { USER_LOGS_CLIENT } from '../../../../Infrastructure/Constants/logsConstant';
import { safeClientLogEvent } from '../../../../Infrastructure/Utilities/safeClientLogEvent';
import { purchaseHistorySx } from './styles';

export const PurchaseHistory = () => {
  const { userId } = useAuthentication()
  const [tab, setTab] = useState("courses");
  const ip = useSelector((state) => state.ip.address)
  const [refundsError, setRefundsError] = useState(null)
  const page = useSelector((state)=> state.route.currentRoute)
  const [purchaseHistoryError, setPurchaseHistoryError] = useState(null)
  const [refundsHistory, setRefundsHistory] = useState(null);
  const [refundsLoading, setRefundsLoading] = useState(null);
  const [paymentHistory, setPaymentHistory] = useState(null);
  const [paymentHistoryLoading, setPaymentHistoryLoading] = useState(null);

  const handleTabChange = (newTab) => {
    if (tab !== newTab) {
      setTab(newTab);
    }
  }
  useEffect(() => {
    async function fetchData() {
      try {
        setPaymentHistoryLoading(true)
        const getPaymentHistory = httpsCallable(functions, "studentpurchasehistory")
        const res = await getPaymentHistory({ student_id: userId, ip, page });
        const sortedPayments = res?.data?.paymentIntents?.sort((a, b) => b.created - a.created);
        setPaymentHistory(sortedPayments)
      } catch (error) {
        setPurchaseHistoryError(ERROR_CONSTANTS.GENERIC_ERROR_VIEW)
        await safeClientLogEvent({
          ...USER_LOGS_CLIENT.GET_ALL_PURCHASES_ERROR,
          uid: userId,
          source: "purchaseHistory.jsx",
          emailInfo: null,
          metadata: null,
          error: error?.message || null
        });
      } finally {
        setPaymentHistoryLoading(false)
      }
    }
    if (userId) {
      fetchData();
    }
  }, [userId, ip, page])
  useEffect(() => {
    async function fetchData() {
      try {
        setRefundsLoading(true)
        const stripeRefunds = httpsCallable(functions, "striperefunds")
        const res = await stripeRefunds({ studentId: userId, ip, page });
        setRefundsHistory(res?.data?.paymentRefunds)
      } catch (error) {
        setRefundsError(ERROR_CONSTANTS.GENERIC_ERROR_VIEW)
       await safeClientLogEvent({
          ...USER_LOGS_CLIENT.GET_ALL_REFUNDS_ERROR,
          uid: userId,
          source: "purchaseHistory.jsx",
          emailInfo: null,
          metadata: null,
          error: error?.message || null
        });
      } finally {
        setRefundsLoading(false)
      }
    }
    if (userId) {
      fetchData();
    }
  }, [userId, ip, page])

  return (
    <MainBox width="full">
      <Box sx={purchaseHistorySx.purchaseHistoryBox}>
        <Typography variant='h1'>Purchase History</Typography>
      </Box>
          <Box width="100%">
            <Box display={'flex'} my={4}>
              <Typography color={tab === 'courses' && "primary"} sx={{ ...purchaseHistorySx.tabTextCourses, borderBottom: tab === 'courses' ? "4px solid" : "4px solid #ccc" }} onClick={() => handleTabChange('courses')}>COURSES</Typography>
              <Typography color={tab === 'refunds' && "primary"} sx={{ ...purchaseHistorySx.tabTextRefunds, borderBottom: tab === 'refunds' ? "4px solid" : "4px solid #ccc" }} onClick={() => handleTabChange('refunds')}>REFUNDS</Typography>
            </Box>

            <MainBox sx={purchaseHistorySx.scrollBox}>
              {
                tab === "courses" ? (
                  paymentHistoryLoading ? (
                    <Box height="80vh">
                      <Loader />
                    </Box>
                  ) : purchaseHistoryError ? <ErrorView/> :  (
                    <CoursesHistory paymentHistory={paymentHistory} />
                  )
                ) : tab === "refunds" ? (
                  refundsLoading ? (
                    <Box height="80vh">
                      <Loader />
                    </Box>
                  ) : refundsError ? <ErrorView/> :  (
                    <Refunds refundsHistory={refundsHistory} />
                  )
                ) : null
              }
            </MainBox>
          </Box>
    </MainBox>
  );
}
